// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Maldives from '../_raw/flag/icon_flag_maldives.png';

export default () => <img src={Maldives} alt="Maldives" />;
